export const surgicalCenterPage = {
	surgical_bed_id: "",
	expertise_id: "",
	surgery_date: "",
	surgical_team_id: "",
	procedure_size: "",
};
